import Icon from '@components/dataDisplay/Icons/Icon';
import Tooltip from '@components/dataDisplay/Tooltip';
import React from 'react';
import styled from 'styled-components';

const InfoBtnWrap = styled.a<{ isTitle?: string }>`
  color: var(--subTextColor);
  font-size: 13px;
  display: inline-block;
  padding: 2px 6px;
  border-radius: 8px;
  display: inline-flex;
  transition: background 0.2s;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background-color: ${({ isTitle }) =>
    isTitle ? 'var(--cardBackgroundColor)' : 'rgba(0,0,0,0.1)'};
  }
`;

const Container = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
`;

function InfoBtn({ linkto, title, tooltip, style }: IinfoLink) {
  return tooltip ? (
    <Tooltip message={tooltip}>
      <InfoBtnWrap href={linkto} target="__blank">
        <Container>
          <Icon name="Info14" color="var(--subTextColor)" />
          {title}
        </Container>
      </InfoBtnWrap>
    </Tooltip>
  ) : (
    <InfoBtnWrap href={linkto} target="__blank" isTitle={title} style={style}>
      <Container>
        <Icon name="Info14" color="var(--subTextColor)" />
        {title}
      </Container>
    </InfoBtnWrap>
  );
}

export default InfoBtn;
